import { render, staticRenderFns } from "./ListCategoryMapping.vue?vue&type=template&id=1d22e634"
import script from "./ListCategoryMapping.vue?vue&type=script&lang=js"
export * from "./ListCategoryMapping.vue?vue&type=script&lang=js"
import style0 from "./ListCategoryMapping.vue?vue&type=style&index=0&id=1d22e634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports